import { SelectChangeEvent } from '@mui/material';
import { GridSortModel } from '@mui/x-data-grid';
import { ChangeEvent, useMemo, useState } from 'react';

import { useCurrentEventQuery } from '../../hooks/useCurrentEventQuery';
import { useEventUsersQuery } from '../../hooks/useEventUsersQuery';

export type VisibleUsersType = 'ALL' | 'INVALID' | 'VALID';

export const useEventUsers = () => {
  const [search, setSearch] = useState<string>('');
  const [visibleUsers, setVisibleUsers] = useState<VisibleUsersType>('ALL');
  const [sortModel, setSortModel] = useState<GridSortModel>([
    {
      field: 'studyTown',
      sort: 'asc',
    },
  ]);

  const { data: currentEventData, loading: isCurrentEventLoading } =
    useCurrentEventQuery();

  const { data: eventUsersData, loading: isEventUsersLoading } =
    useEventUsersQuery(currentEventData?.currentEvent?.id ?? null);

  const eventUsers = useMemo(
    () =>
      (eventUsersData?.eventUsers ?? [])
        .filter((eventUser) => {
          if (visibleUsers === 'ALL') {
            return true;
          }
          if (visibleUsers === 'INVALID') {
            return !eventUser.isValidated;
          }
          return eventUser.isValidated;
        })
        .filter((eventUser) =>
          `${eventUser.firstname} ${eventUser.lastname}. ${eventUser.nickname} ${eventUser.studyTown} ${eventUser.studies} ${eventUser.email}`
            .toLowerCase()
            .includes(search.toLowerCase()),
        ),
    [visibleUsers, eventUsersData?.eventUsers, search],
  );

  const onVisibleUsersChange = (event: SelectChangeEvent<VisibleUsersType>) => {
    setVisibleUsers(event.target.value as VisibleUsersType);
  };

  const clearSearch = () => {
    setSearch('');
  };

  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const onSortModelChange = (newSortModel: GridSortModel) =>
    setSortModel(newSortModel);

  return {
    currentEvent: currentEventData?.currentEvent ?? null,
    visibleUsers,
    eventUsers,
    loading: isCurrentEventLoading || isEventUsersLoading,
    onVisibleUsersChange,
    clearSearch,
    onSearchChange,
    sortModel,
    onSortModelChange,
    search,
  };
};
